import InputNumberRang from './input-number-rang.vue';
export default InputNumberRang;



// WEBPACK FOOTER //
// ./src/components/input-number-rang/index.js